/**
 * This script dynamically adds the `contain` class to product gallery images
 * that are portrait-oriented (height > width). It ensures that tall images are
 * not visually cropped inside landscape containers.
 *
 * Affects:
 * - <img class="main-slide-img">
 * - <img class="imageslide-item_image">
 * - <img class="swiper-slide-image"> (used in some Swiper templates)
 *
 * The corresponding CSS should include:
 *   img.contain { object-fit: contain !important; }
 */
document.addEventListener("DOMContentLoaded", function () {
  const imgs = document.querySelectorAll(
    "img.main-slide-img, img.imageslide-item_image, img.swiper-slide-image"
  );

  imgs.forEach((img) => {
    if (img.complete) {
      handleAspect(img);
    } else {
      img.addEventListener("load", () => handleAspect(img));
    }
  });

  function handleAspect(img) {
    if (img.naturalHeight > img.naturalWidth) {
      img.classList.add("contain");
    } else {
      img.classList.remove("contain");
    }
  }
});
